import React, { createContext, useContext, useState, useCallback } from "react";

/**
 * Persistent call context — hosts a SINGLE global call panel above every
 * route so that navigating between pages doesn't tear down the video iframe.
 *
 * Any page that used to render <EmbeddedMeetPanel /> locally now calls
 * `startCall(callDoc)` and the panel mounts once in <App />.
 */
const CallContext = createContext(null);

export function CallProvider({ children }) {
  // callDoc shape: { roomUrl, displayName, audioOnly, provider, meetingUri, onEnd? }
  const [call, setCall] = useState(null);

  const startCall = useCallback((doc) => {
    setCall(doc || null);
  }, []);

  const endCall = useCallback(() => {
    setCall((c) => {
      try { c?.onEnd?.(); } catch { /* ignore */ }
      return null;
    });
  }, []);

  return (
    <CallContext.Provider value={{ call, startCall, endCall }}>
      {children}
    </CallContext.Provider>
  );
}

export function useCall() {
  const ctx = useContext(CallContext);
  if (!ctx) throw new Error("useCall must be used within CallProvider");
  return ctx;
}
